/**
 * Зависимости
 */
import MapFilter from 'components/yandex-map/infrastructure-checkbox-filter';
import Observer from '../../common/scripts/observer';
import Utils from 'common/scripts/utils';
import YandexMap from 'components/yandex-map';

const observer = new Observer();

/**
 * Карта в блоке Расположение
 */
const filterListBtn = document.querySelector('.j-location-filter-list-toggle');
const filterList = document.querySelector('.j-location-infrastructure');
const locationMap = document.querySelector('.j-location-map');
const filterCheckboxToggler = document.querySelector('.j-checkbox-toggle');
const mapFilterWrapper = document.querySelector('.j-map-filter');

let isLoaded = false;

const initLocationMap = () => {
    isLoaded = true;
    // console.log('Яндекс-карта: скрипт загружен');

    if (mapFilterWrapper) {
        const mapFilter = new MapFilter();

        mapFilter.init({target: mapFilterWrapper});

        if (filterCheckboxToggler) {
            observer.subscribe('filterUpdated', () => {
                const togglerText = filterCheckboxToggler.querySelector('span');

                togglerText.innerHTML = mapFilter.globalFilterState ? 'Скрыть все' : 'Показать все';
            });

            filterCheckboxToggler.addEventListener('click', () => {
                mapFilter.changeCheckBoxState();
            });
        }
    }

    if (filterListBtn && filterList) {
        filterListBtn.addEventListener('click', () => {
            filterList.classList.toggle('is-open');
            filterListBtn.classList.toggle('is-open');
        });
    }

    const ymaps = window.ymaps;

    if (ymaps) {
        ymaps.ready(() => {
            const yandexMap = new YandexMap(ymaps);

            yandexMap.init({
                wrapper                : locationMap,
                cluster                : true,
                fullScreenControl      : true,
                customFullScreenControl: true,
                customZoomControl      : true
            });
        });
    }
};

const checkMap = () => {
    const ymaps = window.ymaps;

    if (ymaps) {
        initLocationMap();
    } else {
        Utils.loadScript('https://api-maps.yandex.ru/2.1/?lang=ru_RU', initLocationMap);
    }
};

if (locationMap) {
    if ('IntersectionObserver' in window) {
        const lazyImageObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    if (!isLoaded) {
                        checkMap();
                    }
                }
            });
        }, {rootMargin: '0px 0px 1000px 0px'});

        if (Utils.isInViewport(locationMap, window.innerHeight || document.documentElement.clientHeight)) {
            checkMap();
        } else {
            lazyImageObserver.observe(locationMap);
        }
    } else {
        checkMap();
    }
}

